import "@/App.css";
import { useEffect } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import { CartProvider } from "@/context/CartContext";
import { AuthProvider } from "@/context/AuthContext";
import { track } from "@/lib/analytics";
import Store from "@/pages/Store";
import Landing from "@/pages/Landing";
import ProductDetail from "@/pages/ProductDetail";
import Admin from "@/pages/Admin";
import Auth from "@/pages/Auth";
import Account from "@/pages/Account";
import PaymentSuccess from "@/pages/PaymentSuccess";
import PaymentCancel from "@/pages/PaymentCancel";

function RouteTracker() {
  const location = useLocation();
  useEffect(() => {
    track("pageview", { path: location.pathname + location.search });
  }, [location.pathname, location.search]);
  return null;
}

function App() {
  return (
    <AuthProvider>
      <CartProvider>
        <BrowserRouter>
          <RouteTracker />
          <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/shop" element={<Store />} />
            <Route path="/storage" element={<Store title="STORAGE & DISPLAY" subtitle="Stackable boxes, LED slide-outs, custom wood crates and wall display cases — built to protect and show off the collection." categories={["storage-boxes", "display-cases"]} showHero={false} />} />
            <Route path="/care" element={<Store title="CLEANING & CARE" subtitle="Cleaners, pre-treatments and whiteners that keep every pair resale-ready." categories={["shoe-care"]} showHero={false} />} />
            <Route path="/product/:id" element={<ProductDetail />} />
            <Route path="/admin" element={<Admin />} />
            <Route path="/login" element={<Auth mode="login" />} />
            <Route path="/register" element={<Auth mode="register" />} />
            <Route path="/account" element={<Account />} />
            <Route path="/payment/success" element={<PaymentSuccess />} />
            <Route path="/payment/cancel" element={<PaymentCancel />} />
          </Routes>
        </BrowserRouter>
        <Toaster position="bottom-right" richColors />
      </CartProvider>
    </AuthProvider>
  );
}

export default App;
